import { FONT_TEXT } from '../../css/customFonts';
import { getStyleById } from '../../theme';
import type { PageProps } from '../../types';
import { Footer } from '../week/Footer';
import { CalendarGrid } from './components/CalendarGrid';
import { PageHeader } from './components/PageHeader';
import type { PageData } from './types';
import { toMonthKey } from './util.lib';

export const Page = ({
  experience,
  data,
  pageIndex,
  isCurrentPage,
}: PageProps<PageData>) => {
  const pageStyles = getStyleById(experience.styleId ?? undefined);

  return (
    <div
      className="page"
      data-current-page={isCurrentPage}
      data-measure={`page-${pageIndex}`}
      style={{
        color: '#000000',
        fontSize: '1em',
        backgroundColor: pageStyles.backgroundColor ?? '#FFFFFF',
        padding: '1em',
      }}
    >
      <div
        style={{
          fontFamily: FONT_TEXT,
          padding: '1em',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        {data.months.map((monthData, monthIndex) => {
          const index = pageIndex + monthIndex;
          const monthKey = toMonthKey(monthData.month);

          return (
            <div
              key={monthKey}
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                position: 'absolute',
                inset: 0,
                backgroundColor: pageStyles.backgroundColor ?? '#FFFFFF',
              }}
            >
              <PageHeader
                month={monthData.month}
                pageIndex={index}
                pageIndexForMonth={data.pageIndexForMonth}
              />

              <div
                style={{
                  position: 'relative',
                  overflow: 'visible',
                  flexGrow: 1,
                }}
              >
                <CalendarGrid
                  experience={experience}
                  monthData={monthData}
                  pageIndex={index}
                />
              </div>

              <Footer
                measureKey={`page-${pageIndex}-footer-${monthKey}`}
                pageIndex={pageIndex}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
